// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__kYfwv","header":"MergedInvoice_header__2It_N"};